var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeClockFileRemoveSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time-clock-file-remove_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elekter---Era---Leping---Expanded",
    transform: "translate(-946.000000, -344.000000)",
    stroke: "#F0B423",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(208.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Detailid",
    transform: "translate(381.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(357.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time-clock-file-remove",
    transform: "translate(0.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 17.25,
    cy: 17.25,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 15,
    x2: 15,
    y2: 19.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 19.5,
    y2: 19.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,14.25 C5.95852152,14.2501807 4.03285023,12.5284013 3.7776412,10.2511789 C3.52243217,7.97395646 5.01919779,5.86862355 7.25386943,5.36155717 C9.48854108,4.85449078 11.7473766,6.1076452 12.5,8.272",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "9.75 9.75 8.25 9.75 8.25 8.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,20.25 L2.25,20.25 C1.42157288,20.25 0.75,19.5784271 0.75,18.75 L0.75,2.25 C0.75,1.42157288 1.42157288,0.75 2.25,0.75 L12.879,0.75 C13.2766907,0.750350104 13.6579653,0.908615025 13.939,1.19 L16.811,4.061 C17.0922632,4.34244347 17.2501803,4.72410629 17.25,5.122 L17.25,7.5",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClockFileRemoveSvg);
export default __webpack_public_path__ + "static/media/time-clock-file-remove_SVG.1d6dee1b558b8661ec9fffca5efc13dc.svg";
export { ForwardRef as ReactComponent };